import { makeSelectAuthApiConfig } from 'services/api/api.selectors';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import { AppState, ReduxSelector } from 'store/types';

const selectFavoritesState = (reduxState: AppState) => reduxState.favorites;

export const selectFavorites = (reduxState: AppState) =>
  selectFavoritesState(reduxState).favorites;

export function makeSelectPostFavoritesApiConfig(): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return function selectPostFavoritesEndpointApiConfig(
    reduxState: AppState,
  ): RequestApiDataIfNecessaryPayload {
    const url = '/favorites-ms/sisal/spbc/v1/hasFavorites';

    return {
      resourceId: url,
      requestConfig: makeSelectAuthApiConfig({
        url,
        method: 'GET',
      })(reduxState),
      invalidateIfPresent: true,
      skipDefaultServerErrorHandling: true,
    };
  };
}
